// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"185":"84dee01c","479":"3f08df05","588":"c84e5b54","854":"41fb497c"}[chunkId] + ".js";
};